export const dashboardConstants = {
    GETALL_REQUEST: 'DASHBOARD_GETALL_REQUEST',
    GETALL_SUCCESS: 'DASHBOARD_GETALL_SUCCESS',
    GETALL_FAILURE: 'DASHBOARD_GETALL_FAILURE',

    GET_LAYOUT_SUCCESS: 'GET_LAYOUT_SUCCESS',
    
    GET_WIDGET_DATA_REQUEST: 'GET_WIDGET_DATA_REQUEST',
    GET_WIDGET_DATA_SUCCESS: 'GET_WIDGET_DATA_SUCCESS'
};
